import dispatcher from '../dispatcher';
import scrollStore from '../scroll/scroll.store';
import vScrollStore from '../scroll/virtual-scroll.store';
import pageLoadStore from '../page-load/page-load.store';
import resizeStore from '../resize/resize.store';
import * as utils from '../utils';
import * as calcProperty from '/src/assets/scripts/modules/utils/calcProperty';
import TweenMax from 'gsap/all';

var elements;
var customElements;
var containerElements;
var globalScrollShift = 20;
var wasInitial = false;

function translateTo(element, translate, opacity, speed) {
	var ease = window._cssEasings.easeOut;

	element.style.webkitTransitionProperty =
		element.style.transitionProperty = 'opacity, transform';

	element.style.webkitTransitionDuration =
		element.style.transitionDuration = speed + 's';

	element.style.webkitTransitionTimingFunction =
		element.style.transitionTimingFunction = 'ease, ' + ease;

	element.style.webkitTransform =
		element.style.transform = 'translateY(' + translate + 'px)';
}

var _handleScroll = function(initial) {
	var wh = resizeStore.getData().height;
	var scrolled = scrollStore.getData().top;
	var loaded = pageLoadStore.getData().loaded;
	var scrollShift = globalScrollShift;

	var checkElement = function(element) {
		var tagName;
		var target, targetElement;
		var event;
		var wh = resizeStore.getData().height;
		var isFirstScreen = element._triggerOffsetTop < wh;
		// var t = {
		// 	v: 0
		// }

		if (element._triggered) return;

		if ((element._triggerOffsetTop < scrolled + wh - scrollShift && loaded) || isFirstScreen) {
			element._triggered = true;

			setTimeout(() => {
				if (element.hasOwnProperty('handleTrigger') &&
					typeof element.handleTrigger === 'function') {
					element.handleTrigger();
				} else {
					TweenMax.to(element._calcProperty.get({
						namespace: 'scroll-trigger'
					}), 2, {
						y: 0,
						opacity: 1,
						ease: window._easings.easeOut,
						onUpdate: function() {
							element._calcProperty.set({
								property: ['y', 'opacity'],
								namespace: 'scroll-trigger',
								value: [this._targets[0].y, this._targets[0].opacity]
							});
						}
					});
				}
				// event = new CustomEvent('trigger', {detail: {}});
				//
				// setTimeout(function() {
				// 	element.dispatchEvent(event);
				// }, 0);
			}, !isFirstScreen ? element._triggerDelay : 0);
		} else {
			if (!element.hasOwnProperty('_triggered') && !element._triggerCustom) {
				element._triggered = false;
				element._calcProperty.set({
					property: ['y', 'opacity'],
					namespace: 'scroll-trigger',
					value: [element._calcProperty.get({
						property: 'y',
						namespace: 'scroll-trigger'
					}), 0]
				});
			}
		}
	}

	if (initial || wasInitial) {
		wasInitial = true;
		scrollShift = 0;
	}

	elements.forEach(checkElement);

	if (loaded) {
		wasInitial = false;
	}
}

var _handleResize = function() {
	elements.forEach(function(element) {
		element._triggerOffsetTop = utils.offset(element).top;
	});
}

var _initElements = function() {
	elements = document.getElementsByClassName('s-trigger');
	containerElements = document.getElementsByClassName('s-trigger-parse');
	elements = Array.prototype.slice.call(elements);

	Array.prototype.forEach.call(containerElements, function(cnt) {
		var newElements = Array.prototype.slice.call(cnt.children);
		elements = elements.concat(newElements);
	});

	elements = Array.prototype.slice.call(elements);
	elements = elements.filter(element => !element.classList.contains('s-trigger-first'));

	elements.forEach(function(element) {
		if (element._triggered) return;

		if (element.hasOwnProperty('handleTrigger') &&
			typeof element.handleTrigger === 'function' ||
			element.classList.contains('custom-trigger')) {
			element._triggerCustom = true;
		}

		if (!element.hasOwnProperty('_triggerOffsetTop')) {
			element._offsetTop = utils.offset(element).top;
		}

		element._triggerDelay = parseFloat(element.getAttribute('data-delay') || 0);

		if (!element._triggerCustom) {
			calcProperty.attach(element, {
				namespace: 'scroll-trigger',
				setStyles: true
			});
			element._calcProperty.set({
				property: ['y', 'opacity'],
				namespace: 'scroll-trigger',
				value: [
					parseInt(element.getAttribute('data-shift') || 80),
					0
				]
			});
		}
	});
}

var _handleDispatcher = function(e) {
	if (e.type === 'content:replaced') {
		_initElements();
		setTimeout(function() {
			_handleResize();
			_handleScroll();
		}, 0);
	}
}

var init = function() {
	_initElements();
	_handleResize();
	_handleScroll(true);
	resizeStore.subscribe(_handleResize);
	vScrollStore.subscribe(_handleScroll);
	dispatcher.subscribe(_handleDispatcher);
	pageLoadStore.subscribe(_handleScroll);
}

export default {
	init: init
}